import { render, staticRenderFns } from "./card-6.vue?vue&type=template&id=47b6c8e7&scoped=true&"
import script from "./card-6.vue?vue&type=script&lang=js&"
export * from "./card-6.vue?vue&type=script&lang=js&"
import style0 from "./card-6.vue?vue&type=style&index=0&id=47b6c8e7&lang=scss&scoped=true&"
import style1 from "./card-6.vue?vue&type=style&index=1&id=47b6c8e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6c8e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VImg,VSkeletonLoader})
